import React, { FC } from "react";
import { useFormContext } from "react-hook-form";
import useTranslation from "next-translate/useTranslation";
import { Input, FormControl, FormErrorMessage } from "@chakra-ui/react";
import { FormLabel } from "./FormLabel";

export interface FormInputProps {
  name: string;
  label?: string;
  type?: string;
  placeholder?: string;
  isRequired?: boolean;
  defaultValue?: string;
}

export const FormInput: FC<FormInputProps> = (props) => {
  const { register, errors } = useFormContext();
  const { t } = useTranslation();
  return (
    <FormControl id={props.name} isInvalid={!!errors[props.name]} isRequired={props.isRequired}>
      {props.label && <FormLabel htmlFor={props.name}>{props.label}</FormLabel>}
      <Input
        ref={register({ required: props.isRequired ? t("shared:formRequiredField") : undefined })}
        name={props.name}
        type={props.type}
        placeholder={props.placeholder}
        defaultValue={props.defaultValue}
        height={"50px"}
        bg={"rgba(255, 255, 255, 0.8)"}
        border={"1px solid"}
        borderColor={"#BBD1F2"}
        borderRadius={"2px"}
        boxShadow={"0px 20px 32px rgba(70, 25, 164, 0.05)"}
        fontFamily="Montserrat"
        fontSize={"14px"}
        fontWeight={"500"}
        lineHeight={"110%"}
      />
      <FormErrorMessage>{errors[props.name]?.message}</FormErrorMessage>
    </FormControl>
  );
};
